import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  changeFile(event) {
    const selected_file = document.getElementById("selected-file")
    if (event.target.files.length > 0) {
      selected_file.innerHTML = '選択中のファイル：' + event.target.files[0].name;
    } else {
      selected_file.innerHTML = '選択されていません';
    }
  }

  change(event) {
    const deleteBtn = document.getElementById("delete-btn")
    if (event.target.files.length > 0) {
      deleteBtn.hidden = false;
    } else {
      deleteBtn.hidden = true;
    }
  }

  delete(event) {
    event.target.hidden = true;
    document.getElementById('file-selector').value = ''
  }
}
